import { publicConfig } from 'config'
import { useEffect } from 'react'
import { init } from 'shared-code/algolia-insights'
import AdBlockerScript from 'shared-components/ad/AdBlockerScript'
import PlaywireRampScript from 'shared-components/ad/PlaywireRampScript'
import AffilimateScript from 'shared-components/thirdparty/AffilimateScript'
import FunnelScript from 'shared-components/thirdparty/FunnelScript'
import GTM from 'shared-components/thirdparty/GTM'
import GtmGtag from 'shared-components/thirdparty/GtmGtag'
import OneSignalScript from 'shared-components/thirdparty/OnesignalScript'
import OptimizeScript from 'shared-components/thirdparty/OptimizeScript'

const Thirdparty: React.VFC = () => {
  const optimizeId = publicConfig('googleOptimizeId')

  const funnelId = publicConfig('funnelCustomerId')

  const onesignalId = publicConfig('oneSignalAppId')
  const onesignalDelay = publicConfig('onesignalLoadDelay')
  const onesignalLimit = publicConfig('oneSignalTagLimit')

  const adsDisabled = publicConfig('adsDisabled')
  const playwirePublisher = publicConfig('playwirePublisher')
  const playwireWebsite = publicConfig('playwireWebsite')

  const adBlockScript = publicConfig('adBlockerScript')

  const gtmId = publicConfig('gtmDesktopId')

  useEffect(() => {
    const algoliaAppId = publicConfig('algoliaAppId')
    const algoliaKeyId = publicConfig('algoliaKeyId')
    const algoliaSearchIndex = publicConfig('algoliaSearchIndex')

    if (algoliaAppId && algoliaKeyId && algoliaSearchIndex) {
      init(algoliaAppId, algoliaKeyId, algoliaSearchIndex)
    }
  }, [])

  const affilimateToken = publicConfig('affilimateToken')
  const gtagId = publicConfig('gtmGtagId')

  return (
    <>
      {affilimateToken ? <AffilimateScript token={affilimateToken} /> : null}
      {gtmId ? <GTM gtmId={gtmId} /> : null}
      {!adsDisabled && playwirePublisher && playwireWebsite ? (
        <PlaywireRampScript publisherId={playwirePublisher} websiteId={playwireWebsite} />
      ) : null}

      {optimizeId ? <OptimizeScript optimizeId={optimizeId} /> : null}

      {funnelId ? <FunnelScript customerId={funnelId} /> : null}
      {onesignalId ? (
        <OneSignalScript appId={onesignalId} loadDelay={onesignalDelay} tagLimit={onesignalLimit} />
      ) : null}
      <AdBlockerScript blockScript={adBlockScript} />
      {gtagId ? (
        <GtmGtag
          id={gtagId}
          event={`gtag('event', 'conversion_event_page_view', {
    // <event_parameters>
  });`}
        />
      ) : null}
    </>
  )
}

export default Thirdparty
